import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button", "status"];

  copy(event) {
    event.preventDefault();
    const value = this.inputTarget?.value || this.element.querySelector("input")?.value || "";
    if (!value) return;

    const write = async (text) => {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.setAttribute("readonly", "");
          ta.style.position = "absolute";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.flash();
      } catch (e) {
        console.warn("Clipboard copy failed", e);
      }
    };

    write(value);
  }

  flash() {
    const btn = this.hasButtonTarget ? this.buttonTarget : this.element.querySelector("button");
    if (!btn) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Copied!";
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 1200);
  }
}


